/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BehaviouralPainScore from './behavioural-pain-score';
import BehaviouralPainScoreDetail from './behavioural-pain-score-detail';
import BehaviouralPainScoreUpdate from './behavioural-pain-score-update';
import BehaviouralPainScoreDeleteDialog from './behavioural-pain-score-delete-dialog';

const BehaviouralPainScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BehaviouralPainScore />} />
    <Route path="new" element={<BehaviouralPainScoreUpdate />} />
    <Route path=":id">
      <Route index element={<BehaviouralPainScoreDetail />} />
      <Route path="edit" element={<BehaviouralPainScoreUpdate />} />
      <Route path="delete" element={<BehaviouralPainScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BehaviouralPainScoreRoutes;
